import { Typography as MuiTypography } from "@mui/material";
import { styled } from "@mui/material/styles";

const Typography = styled(MuiTypography)(({ styles }) => ({
  color: "var(--text-primary)",

  "&.Mui-disabled": {
    color: "var(--text-disabled)",
  },

  "&.Mui-error": {
    color: "var(--text-error)",
  },

  "&.Mui-warning": {
    color: "var(--text-warning)",
  },

  "&.Mui-success": {
    color: "var(--text-success)",
  },

  ...styles,
}));

export default Typography;
